import * as React from "react";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Button, Grid } from "components/controls/widget";
import YesNoDialog, { YesNoDialogProps } from "common/components/controls/YesNoDialog"
import Error from "common/components/controls/Error";
import apiOznameniPrestupu, { OznData } from "common/api/SendEmailNotifications/OznameniPrestupu";
import PrestupyUtils from "common/utils/PrestupyUtils";
import { Prestup, StornoPrestupu as apiStornoPrestupu } from "common/api/Evidence/Clenove/Prestupy";

interface StornovaniProps {
    prestup: Prestup;
    je_to_clen: boolean;
    je_to_nov_klub: boolean;
    prest_do_divize: boolean;
    setPrestup: (prestup: Prestup) => void;
}

interface State {
    showDialog: boolean;
    submitting?: boolean;
    hasError: boolean;
    error?: React.ReactNode;
}

type Props = StornovaniProps & State & ActionsExecutorPropsType;


const initialState: State = {
    showDialog: false,
    hasError: false,
}



class Stornovani extends React.PureComponent<Props & WithStyles<typeof styles>>{

    handleClose = (cancel: boolean) => {
        if (cancel) {
            this.showDialog(false);
        } else {
            const { executeAction, prestup } = this.props
            const action1 = apiStornoPrestupu(prestup.id)
                .onSuccess(p => {
                    const action2 = apiOznameniPrestupu()
                        .onSuccess(() => this.close(p))
                        .onError(() => this.close(p));
                    executeAction(action2, {}, { prestupId: p.id, typZpravy: PrestupyUtils.TypZpravy_Stornovan })
                })
                .onValidationFailed(e => this.setError(e['_error']))
                .onError(e => this.setError(e.message));

            executeAction(action1, { submitting: true, hasError: false, error: undefined });
        }
    }

    setError = (error: string | string[]) => {
        this.props.updateState({ submitting: false, hasError: true, error: error });
    }

    showDialog = (show: boolean) => {
        if (this.props.showDialog !== show) {
            this.props.updateState({ submitting: false, showDialog: show, hasError: false, error: undefined });
        }
    }

    close = (prestup: Prestup) => {
        this.showDialog(false);
        this.props.setPrestup(prestup);
    }

    render() {
        const { showDialog, submitting, prestup, je_to_clen, je_to_nov_klub, prest_do_divize, classes, hasError, error } = this.props;

        const dlgProps: YesNoDialogProps = {
            show: showDialog,
            submitting: submitting,
            handleClose: this.handleClose,
            title: 'Stornování přestupu',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const stavOK = (prestup.stav == PrestupyUtils.Stav_PotvrzeniIC || prestup.stav == PrestupyUtils.Stav_ZaplaceniPopl);
        const zobrazit = (stavOK && ((je_to_clen && prest_do_divize) || (je_to_nov_klub && !prest_do_divize)));


        return zobrazit ? <div className={classes.root}>
            <Button color="danger" variant="contained" onClick={() => this.showDialog(true)}>{'Stornovat přestup'}</Button>
            <YesNoDialog {...dlgProps}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu chcete stornovat přestup?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
        </div> : null;
    }
}

export const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(withActionsExecutor<StornovaniProps, State>(initialState, Stornovani));